import React, { useState } from "react";
import Navauth from "../partials/navauth";
import { NavLink, useNavigate } from "react-router-dom";
import contact from "../../images/contact.png";
import resend from "../../images/resend.png";
import OtpInput from "react-otp-input";
import { useOtp } from "../../api/mutations";
import { Button, useToast } from "../../lib";
import { useRecoilState } from "recoil";
import { auth_user } from "../../atom";

const Otp = ({ signup = false }) => {
  const [otp, setOtp] = useState("");
  const toast = useToast();
  const navigate = useNavigate();
  const [user] = useRecoilState(auth_user);

  const { mutate, isPending, isError, error } = useOtp(signup);

  const handleVerifyOtp = () => {
    mutate(
      { externalUserId: user?.externalId, submittedOTP: otp },
      {
        onSuccess: (data) => {
          toast({
            type: "success",
            message: "OTP Verified",
          });
          navigate("/login");
        },
        onError: (err) => {
          toast({
            type: "error",
            message: err?.response?.data?.message ?? "An Error occured",
          });
        },
      }
    );
  };

  return (
    <div className="mt-8">
      <Navauth />
      <div className="landing-row py-20">
        <div className="lg:px-[120px]">
          <div className="col-lg-12 pt-24">
            <div className="flex flex-col md:flex-row md:justify-between lg:flex-row lg:justify-between lg:items-center">
              <h3 className="header-signup lg:text-[35px] text-[22px] whitespace-nowrap md:text-[40px]">
                Otp Validation
              </h3>{" "}
              <span className="terms flex items-center">
                <img
                  src={contact}
                  className="img-fluid contact"
                  alt="contact"
                />
                Contact Support
              </span>
            </div>
            <div className="">
              <div className="flex lg:mt-8 md:mt-8 md:flex-row md:justify-between md:items-center lg:flex-row flex-col justify-between lg:items-center">
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  inputStyle={{
                    width: "100%",
                    flex: 1,
                    height: "67px",
                    borderRadius: "27px",
                    background: "#F7F7F7",
                    border: "none",
                    outline: "none",
                  }}
                  containerStyle="containerstyles"
                  renderSeparator={<span style={{}}></span>}
                  renderInput={(props) => <input {...props} />}
                />

                <p className="lg:text-[22px] lg:mt-0 mt-4 text-[17px]">
                  We need to be sure it’s you 😁
                </p>
              </div>
              <div className="flex lg:flex-row md:flex-row md:justify-between md:items-center flex-col lg:justify-between lg:mt-0 mt-[2rem] lg:items-center mt-6">
                <p className="whitespace-nowrap">
                  <span className="text-[#242426] texts font-normal lg:mt-0 text-[14px] lg:text-[18px]">
                    Enter 4 digit pin received in your Mail Inbox or <br /> Spam
                    box
                  </span>
                  <span className="gap-4 mx-2 texts text-[#707A8A] lg:text-[18px] text-[14px]">
                    1:00
                  </span>
                  <span className="terms">
                    Resend pin
                    {/* <img
                      src={resend}
                      className="absolute top-[.2rem] right-[-22px] w-[17px] h-[17px]"
                      alt="resend"
                    /> */}
                  </span>
                </p>

                <div className="col-md-6 col-12 mx-auto flex justify-start md: justify-end lg:justify-end">
                  {/* <NavLink to="/updated"> */}
                  <Button
                    className="btn-cuppy"
                    loading={isPending}
                    onClick={handleVerifyOtp}
                  >
                    Validate & Continue
                  </Button>
                  {/* </NavLink> */}
                </div>
              </div>
              <div className="col-md-6 col-12">
                <p className="forgot mt-4">
                  Already have an Account?{" "}
                  <span className="terms">
                    {" "}
                    <NavLink to="/login" className="login">
                      {" "}
                      Login{" "}
                    </NavLink>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Otp;
